module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-500.f0f2716c.woff2";